import React, { PureComponent, Fragment } from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import NotFoundBanner from './404-banner';  
function NotFoundPage() {

  return (
        <Fragment>
          <Header/>
          <NotFoundBanner/>    
          <Footer />
        </Fragment>
  
    );
  }
  
  export default NotFoundPage;